// @styles/theme/flowbiteAccordionTheme.ts
import { createTheme } from 'flowbite-react';

export const customAccordionTheme = createTheme({
  root: {
    base: "border-l-0 border-r-0 border-b-0 border-gray-300 dark:border-gray-300",
    flush: {
      off: "rounded-none border border-l-0 border-r-0 border-b-0",
      on: "",
    },
  },
  content: {
    base: "[&:not([hidden])]:flex flex-col gap-4 text-base font-normal text-gray-600 border-b border-gray-300 dark:border-gray-300 pl-5 md:pl-24 pr-5 pt-4 pb-8 last:rounded-b-lg dark:bg-transparent",
  },
  title: {
    arrow: {
      base: "h-6 w-6 shrink-0",
      open: {
        off: "",
        on: "ease-in-out duration-300 !rotate-45",
      },
    },
    base: "textflex w-full gap-5 focus:ring-0 items-center justify-between py-8 px-5 text-left font-medium text-gray-500 dark:text-gray-500",
    flush: {
      off: "border-b border-gray-300 dark:border-gray-300 focus:ring-0 leading-tight text-xl md:text-3xl font-semibold text-gray-900 hover:bg-transparent dark:hover:bg-transparent",
      on: "border-gray-50 bg-transparent dark:bg-transparent",
    },
    heading: "",
    open: {
      off: "text-gray-900 dark:text-gray-900",
      on: "!pb-0 !border-none text-gray-900 bg-transparent dark:bg-transparent dark:text-gray-900",
    },
  },
});
